import { render } from "./inventoryLedger.vue?vue&type=template&id=67c54e1c"
import script from "./inventoryLedger.vue?vue&type=script&lang=js"
export * from "./inventoryLedger.vue?vue&type=script&lang=js"

import "./inventoryLedger.vue?vue&type=style&index=0&id=67c54e1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__